export default "__VITE_ASSET__D1FlqBcA__"